import React, { forwardRef, useId } from 'react';
import Field, { errorId, hintId } from '../Field/Field';
import { cx, describedBy } from '../utils';
import './Textarea.css';

const Textarea = forwardRef(function Textarea(
  {
    id,
    label,
    hint,
    error,
    disabled,
    required,
    rows = 4,
    className,
    wrapperClassName,
    'aria-describedby': ariaDescribedBy,
    ...rest
  },
  ref
) {
  const autoId = useId();
  const textareaId = id || autoId;

  return (
    <Field
      id={textareaId}
      label={label}
      hint={hint}
      error={error}
      required={required}
      className={wrapperClassName}
    >
      <div className={cx('ui-control', error && 'ui-control--invalid')}>
        <textarea
          {...rest}
          ref={ref}
          id={textareaId}
          rows={rows}
          disabled={disabled}
          required={required}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy(
            error ? errorId(textareaId) : hint && hintId(textareaId),
            ariaDescribedBy
          )}
          className={cx('ui-control__field', 'ui-textarea', className)}
        />
      </div>
    </Field>
  );
});

export default Textarea;
